module.exports = __webpack_public_path__ + "img/android_2.90535142.jpeg";